import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService, SupabaseBaseHttpService, ViewRowModel } from '@examdojo/supabase';
import { isNotNullish } from '@examdojo/util/nullish';
import { from } from 'rxjs';
import { CourseHttpModel, Program } from '../model';
import { SyllabusAndCourseLevel, SyllabusHttpModel } from './syllabus.model';

@Injectable({
  providedIn: 'root',
})
export class SyllabusHttpService extends SupabaseBaseHttpService<'syllabuses', 'categories'> {
  constructor(protected override readonly supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'categories';
  readonly tableName = 'syllabuses';

  fetchAllActiveWithPrograms(filters?: { programId?: Program }) {
    let query = this.supabase.client.schema(this.schema).from('syllabuses_with_programs').select().eq('active', true);

    if (isNotNullish(filters?.programId)) {
      query = query.eq('program', filters?.programId);
    }

    return from(
      query
        .throwOnError()
        .then(
          (response) =>
            response.data! as Array<SyllabusHttpModel & ViewRowModel<'syllabuses_with_programs', 'categories'>>,
        ),
    );
  }

  fetchAllWithPrograms(filters?: { programId?: Program }) {
    let query = this.supabase.client.schema(this.schema).from('syllabuses_with_programs').select();

    if (isNotNullish(filters?.programId)) {
      query = query.eq('program', filters?.programId);
    }

    return from(
      query
        .throwOnError()
        .then(
          (response) =>
            response.data! as Array<SyllabusHttpModel & ViewRowModel<'syllabuses_with_programs', 'categories'>>,
        ),
    );
  }

  fetchCourses(program?: Program) {
    let query = this.supabase.client.schema(this.schema).from('syllabuses_with_courses').select().eq('active', true);

    if (isNotNullish(program)) {
      query = query.eq('program', program);
    }

    return from(query.throwOnError().then((response) => response.data! as CourseHttpModel[]));
  }

  fetchSubscribedCoursesForProgram(program: Program) {
    const query = this.supabase.client
      .schema(this.schema)
      .rpc('get_user_subscribed_courses', { program_filter: program });

    return from(
      query.throwOnError().then(
        (response) =>
          response.data!.map((item) => ({
            syllabusId: item.syllabus_id,
            courseLevel: item.course_level,
          })) as SyllabusAndCourseLevel[],
      ),
    );
  }
}
